import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject, filter } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BlueprintStateService {
  private searchTermSubject = new BehaviorSubject<string>('');
  searchTerm$ = this.searchTermSubject.asObservable();

  private searchCountSubject = new BehaviorSubject<number>(0);
  searchCount$ = this.searchCountSubject.asObservable();

  private searchIndexSubject = new BehaviorSubject<number>(0);
  searchIndex$ = this.searchIndexSubject.asObservable();

  private searchNavigateSubject = new Subject<'next' | 'prev'>();
  searchNavigate$ = this.searchNavigateSubject.asObservable();

  private changesetMarkersSubject = new BehaviorSubject({});
  changesetMarkersSubject$ = this.changesetMarkersSubject.asObservable();

  private zoomChangeSubject = new Subject<'in' | 'out' | 'reset'>();
  zoomChange$ = this.zoomChangeSubject.asObservable();

  private currentZoomSubject = new BehaviorSubject<number>(100);
  currentZoom$ = this.currentZoomSubject.asObservable();

  private zoomWarningSubject = new Subject<void>();
  zoomWarning$ = this.zoomWarningSubject.asObservable();

  private overallStatusSubject = new BehaviorSubject<string>('DRAFT');
  overallStatus$ = this.overallStatusSubject.asObservable();

  private isWelcomeScreenActiveSubject = new BehaviorSubject<boolean>(false);
  isWelcomeScreenActive$ = this.isWelcomeScreenActiveSubject.asObservable();

  setSearchTerm(term: string) {
    this.searchTermSubject.next(term);
  }

  setSearchCount(count: number) {
    this.searchCountSubject.next(count);
  }

  setSearchIndex(index: number) {
    this.searchIndexSubject.next(index);
  }

  navigateSearch(direction: 'next' | 'prev') {
    this.searchNavigateSubject.next(direction);
  }

  setChangesetMarkers(revisedConfig: any) {
    this.changesetMarkersSubject.next(revisedConfig);
  }

  triggerZoom(action: 'in' | 'out' | 'reset') {
    this.zoomChangeSubject.next(action);
  }

  triggerZoomWarning() {
    this.zoomWarningSubject.next();
  }

  setCurrentZoom(zoomPercentage: number) {
    this.currentZoomSubject.next(zoomPercentage);
  }

  setOverallStatus(status: string) {
    this.overallStatusSubject.next(status);
  }

  setWelcomeScreenActive(isActive: boolean) {
    this.isWelcomeScreenActiveSubject.next(isActive);
  }

  resetState() {
    this.searchTermSubject.next('');
    this.searchCountSubject.next(0);
    this.searchIndexSubject.next(0);
    this.changesetMarkersSubject.next({});
    this.currentZoomSubject.next(100);
    this.overallStatusSubject.next('DRAFT');
    this.isWelcomeScreenActiveSubject.next(false);
  }
}
